import { render, staticRenderFns } from "./SearchNew.vue?vue&type=template&id=b7743450&scoped=true&"
import script from "./SearchNew.vue?vue&type=script&lang=js&"
export * from "./SearchNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7743450",
  null
  
)

export default component.exports